import { Combo } from './combo.model';
import { AnexoCapacitadora } from 'app/entity/anexo-capacitadora.model';
import { EnderecoCapacitadora } from 'app/entity/endereco-capacitadora.model';
import { ResumoHomologacaoCurso } from './resumo-homologacao.model';
import { HomologacaoCapacitadora } from 'app/entity/homologacao-capacitadora.model';
import { CapacitadoraResponsavel } from './capacitadora-responsavel.model';
import { EmailCapacitadora } from './email-capacitadora.model';
import { TelefoneCapacitadora } from './telefone-capacitadora.model';

export class Capacitadora
{
    public id : number;
    public cnpj : string;
    public nome : string;
    public id_classificacao: number;
    public url : string;
    public observacao: string;
    public aceite : boolean;
    public id_situacao : number;
    public codigo : string;
    public id_lotacao: number;

    public classificacao : Combo;
    
    public anexo_capacitadora: AnexoCapacitadora[];
    public email_capacitadora: EmailCapacitadora[];
    public telefone_capacitadora:TelefoneCapacitadora[];
    public endereco_capacitadora: EnderecoCapacitadora[];
    public capacitadora_responsavel: CapacitadoraResponsavel[];
    public homologacao_capacitadora: HomologacaoCapacitadora[];

}


// WEBPACK FOOTER //
// ./src/app/entity/capacitadora.model.ts